<template>
  <div v-if="!isGuest" class="ui grid">
    <div class="row">
      <h1 class="ui huge header">Welcome</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <sui-button primary style="margin-top: 4px" content="How to create & save a class list" icon="question circle"
        v-on:click="openGallery(4)" />
      <!-- <sui-button
        primary
        style="margin-top: 4px"
        content="How to upload a class list"
        icon="question circle"
        v-on:click="openGallery(5)"
      />
      <sui-button
        primary
        style="margin-top: 4px"
        content="How to add or remove a student"
        icon="question circle"
        v-on:click="openGallery(0)"
      /> -->
      <sui-button primary style="margin-top: 4px" content="How to extend a sociogram" icon="question circle"
        v-on:click="openGallery(2)" />
      <sui-button primary style="margin-top: 4px" content="How to generate a link to take the sociogram"
        icon="question circle" v-on:click="openGallery(3)" />
    </div>
    <div class="row">
      <p v-if="user">
        Welcome {{ user.profile.name }}! Please select one of the following
        options below to get started
      </p>
    </div>
    <div class="row">
      <div class="ui divided items">
        <div class="item">
          <div class="image">
            <router-link to="/class/select"><i class="massive users icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Manage classes</div>
            <div class="meta">
              <span>Select to manage the student classes</span>
            </div>
            <div class="description">
              <!-- eslint-disable-next-line max-len -->
              With this option you can create or edit classes and when ready
              allow students to access the Sociometric instrument.
            </div>
          </div>
        </div>
        <div class="item">
          <div class="image">
            <router-link to="/test/select"><i class="massive id card icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Sociometric Reports</div>
            <div class="meta">
              <span>Select to look up an existing Report</span>
            </div>
            <div class="description">
              With this option you can look up an already created Report
            </div>
          </div>
        </div>
        <div class="item">
          <div class="image">
            <router-link to="/training"><i class="massive file powerpoint icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Training</div>
            <div class="meta">
              <span>Select to view the available training material</span>
            </div>
            <div class="description">
              With this option you can view the available training material, offering videos and case studies.
            </div>
          </div>
        </div>
        <div class="item">
          <div class="image">
            <router-link to="/resources"><i class="massive file icon"></i></router-link>
          </div>
          <div class="content">
            <div class="header">Resources</div>
            <div class="meta">
              <span>Select to view the available resources</span>
            </div>
            <div class="description">
              With this option you can view the available resources, offering resources for primary and post-primary
              schools.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {},
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    isGuest: {
      get() {
        return this.user && this.user.profile &&
          (this.user.profile.role === 'Guest');
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    openGallery(index) {
      this.$store.dispatch('showImage', { index });
    },
  },
  created() {
    this.$store.dispatch('hideLoader');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue